import { createRelayResource } from '@townsquare/relay-utils';

import ReactionUpdateActionQuery from './__generated__/ReactionUpdateActionQuery.graphql';
import { ReactionUpdateActionQuery as ReactionUpdateActionQueryType } from './__generated__/ReactionUpdateActionQuery.graphql';

export const reactionUpdateActionResource = createRelayResource<ReactionUpdateActionQueryType>({
	getQuery: (routerContext) => {
		const { id } = routerContext?.match?.params || {};
		// the id parameter is either a base64-encoded Relay ID, or a URL-encoded ARI.
		// Nothing happens when you URL-decode a base64-encoded string, so we can unconditionally decode the id parameter safely - it won't affect Relay IDs.
		const decodedId = id ? decodeURIComponent(id) : '';
		return {
			query: ReactionUpdateActionQuery,
			variables: {
				id: decodedId,
			},
		};
	},
});
